import Colors from '../../../../shared/assets/style/default/color';
import Fonts from '../../../../shared/assets/style/default/fonts';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const ScoreDenominator = styled.div<React.CSSProperties>`
  color: ${Colors['light']};
  font-family: ${Fonts['regular']};
  font-size: ${28 * Screen.widthRatio}px;
  margin-left: ${8 * Screen.widthRatio}px;
`;

export default ScoreDenominator;
